import React, {useContext, useEffect, useState} from "react";
import {TranslateContext} from "../../context/TranslateContext";
import {useHistory} from "react-router-dom";
import {getStatiKpiApi} from "./services/StatiServices";
import ConfStatiKpiView from "./ConfStatiKpiView";

export default function ConfStatiKpiController() {

    const [loadingData, setLoadingData] = useState(true);
    const [stati_kpi, setStati_kpi] = useState([]);

    const {translate} = useContext(TranslateContext);

    const history = useHistory();

    async function getStati_kpi() {
        const response = await getStatiKpiApi();
        setStati_kpi(response.data.data);
        setLoadingData(false);
    }

    useEffect(() => {
        getStati_kpi();
    }, []);

    function onRowDbClick(row) {
        history.push(`/upd-stato-kpi/${row.id_stato_kpi}`);
    }

    return (
        !loadingData &&
        <ConfStatiKpiView
            translate={translate}
            stati_kpi={stati_kpi}
            onRowDbClick={onRowDbClick}
        />
    );
}
